
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import DeviceDetailView from '@/components/device-detail/DeviceDetailView';
import GasDeviceDetailView from '@/components/device-detail/GasDeviceDetailView';
import WaterDeviceDetailView from '@/components/device-detail/WaterDeviceDetailView';
import { Device } from './gis-map/types';

interface DeviceDetailsTabProps {
  selectedDeviceId: string | null;
  utilityType: 'energy' | 'gas' | 'water';
  deviceHealthData: {
    smartMeters: any[];
    gateways: any[];
  };
  deviceData?: Device | null;
  handleBackToOverview: () => void;
}

const DeviceDetailsTab: React.FC<DeviceDetailsTabProps> = ({
  selectedDeviceId,
  utilityType,
  deviceHealthData,
  deviceData,
  handleBackToOverview
}) => {
  if (!selectedDeviceId) {
    return (
      <div className="p-6 bg-gray-50 dark:bg-gray-800 rounded-lg text-center">
        <p className="text-muted-foreground">Select a device from the Overview tab to view details</p>
        <Button onClick={handleBackToOverview} className="mt-4">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Go to Overview
        </Button>
      </div>
    );
  }

  // Log device data for debugging
  React.useEffect(() => {
    if (deviceData) {
      console.log('Device data in details tab:', deviceData);
    }
  }, [deviceData]);

  // Render the appropriate device detail view based on utility type
  const renderDeviceDetailView = () => {
    switch (utilityType) {
      case 'gas':
        return (
          <GasDeviceDetailView 
            deviceId={selectedDeviceId} 
            deviceData={deviceHealthData}
          />
        );
      case 'water':
        return (
          <WaterDeviceDetailView 
            deviceId={selectedDeviceId} 
            deviceData={deviceHealthData}
          />
        );
      default:
        return (
          <DeviceDetailView 
            deviceId={selectedDeviceId} 
            deviceData={deviceHealthData}
            gisDeviceData={deviceData}
          />
        );
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center">
        <Button variant="outline" size="sm" onClick={handleBackToOverview}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Overview
        </Button>
        {deviceData && (
          <div className="ml-4 text-sm text-muted-foreground">
            Viewing: {deviceData.name} ({deviceData.id})
          </div>
        )}
      </div>
      {renderDeviceDetailView()}
    </div>
  );
};

export default DeviceDetailsTab;
